import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { XCloseIcon } from '@rsos/assets/icons';
import { Text, Box } from '@rsos/components/capstone/base';
import { resetNewDataSource, selectUserPermissionsByApp } from '@rsos/sinatra';
import {
  ButtonWrapper,
  DataSourceBannerWrapper,
  DataSourceTextWrapper,
  DataSourceTitleWrapper,
  ViewDataSourceButton,
} from './DataSourceBanner.styles.js';

const DataSourceBanner = () => {
  const dispatch = useDispatch();
  const { hasNewDataSource, newDataSourceList, profile } = useSelector(
    state => state.sinatra.user,
  );
  const user = useSelector(state => state.sinatra.user);
  const permissions = profile && selectUserPermissionsByApp(user, 'capstone');

  const [isBannerVisible, setIsBannerVisible] = useState(hasNewDataSource);

  const handleClose = () => {
    dispatch(resetNewDataSource(false));
    localStorage.setItem('acknowledgeBanner', true);
    setIsBannerVisible(false);
  };

  const handleRedirect = () => {
    localStorage.setItem('acknowledgeBanner', true);
    window.location = '/admin/data-source';
  };

  const hasDataSourcePermission =
    permissions && permissions.includes('MANAGE_DATA_SOURCES');

  if (!hasNewDataSource) return null;

  return (
    <>
      {isBannerVisible && hasDataSourcePermission && (
        <DataSourceBannerWrapper>
          <DataSourceTextWrapper>
            <Text size="large" fontWeight="bold" mr="3px" color="primaryBase">
              New!
            </Text>
            <DataSourceTitleWrapper ellipsis color="primaryBase">
              You have new data sources available -{' '}
              {newDataSourceList.map((datasource, idx) => (
                <span key={idx}>
                  {datasource.display_name}
                  {idx < newDataSourceList.length - 1 && ', '}
                </span>
              ))}
            </DataSourceTitleWrapper>
          </DataSourceTextWrapper>
          <Box horizontal align="center" flow={10}>
            <Box width={75}>
              <ViewDataSourceButton onClick={handleRedirect}>
                View
              </ViewDataSourceButton>
            </Box>
            <ButtonWrapper onClick={handleClose}>
              <XCloseIcon />
            </ButtonWrapper>
          </Box>
        </DataSourceBannerWrapper>
      )}
    </>
  );
};

export default DataSourceBanner;
